import React, { useMemo } from "react";
import { Alert, Form } from "react-bootstrap";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import SearchableSelect from "components/SearchableSelect";
import FormInput from "components/FormInput/index";

const TransferLicenseModal = ({
  show,
  onClose,
  currentCompanyName,
  selectedLicense,
  selectedTargetCompany,
  onTargetCompanyChange,
  transferReason,
  onReasonChange,
  loadCompanyOptions,
  onConfirmTransfer,
  transferError,
  isSubmitting,
}) => {
  const transferDisabled = useMemo(() => {
    return !selectedTargetCompany || !transferReason || transferReason.trim() === "" || isSubmitting;
  }, [selectedTargetCompany, transferReason, isSubmitting]);

  return (
    <ConfirmationModal
      dialogClassName="modal-md"
      centered
      show={show}
      onHide={onClose}
      title="Transfer License"
      confirmButtonLabel={isSubmitting ? "Transferring..." : "Transfer"}
      confirmButtonVariant="primary"
      isLoading={isSubmitting}
      onConfirm={() => {
        if (transferDisabled) return;
        onConfirmTransfer();
      }}
    >
        {transferError ? <Alert variant="danger">{transferError}</Alert> : null}

        <div className="mb-2">
          <strong>License:</strong> {selectedLicense?.licenseNumber || "N/A"}
        </div>
        <div className="mb-2">
          <strong>License Type:</strong> {selectedLicense?.licenseType || "N/A"}
        </div>
        <div className="mb-3">
          <strong>Current Company:</strong> {currentCompanyName || "N/A"}
        </div>

        <div className="mb-3">
          <Form.Label>Select target company</Form.Label>
          <SearchableSelect
            loadOptions={loadCompanyOptions}
            value={selectedTargetCompany}
            onChange={onTargetCompanyChange}
          />
        </div>

        <div className="mb-2">
          <FormInput
            type="textarea"
            label="Reason"
            rows={3}
            value={transferReason}
            onChange={(e) => onReasonChange(e.target.value)}
            maxLength={500}
            placeholder="Enter reason for transfer"
          />
        </div>
    </ConfirmationModal>
  );
};

export default TransferLicenseModal;
